(function () {
  const MADE_IN_STRONG = /\s*<strong>•\s*Made in:\s*<\/strong>\s*[^<]*/gi;
  const MADE_IN_PLAIN = /\s*•\s*Made in:\s*[^<•\n]*/gi;
  const LANGUAGE_STRONG = /\s*<strong>•\s*Language:\s*<\/strong>\s*[^<]*/gi;
  const LANGUAGE_PLAIN = /\s*•\s*Language:\s*[^<•\n]*/gi;
  const TITLE_MADE_IN_RE = /[-–—]?\s*Made\s+In\s+[A-Za-z\s]+$/i;

  function run() {
    const containers = document.querySelectorAll(
      '.accordion-content, [data-accordion] .accordion-content, .product-accordion-item, .details__content, .specification, .product-details'
    );
    for (const el of containers) {
      let raw = el.innerHTML;
      raw = raw.replace(MADE_IN_STRONG, '').replace(MADE_IN_PLAIN, '');
      raw = raw.replace(LANGUAGE_STRONG, '').replace(LANGUAGE_PLAIN, '');
      el.innerHTML = raw;
    }

    const titles = document.querySelectorAll('h1.heading');
    for (const title of titles) {
      const original = title.textContent || '';
      const cleaned = original.replace(TITLE_MADE_IN_RE, '').trim();
      if (cleaned && cleaned !== original.trim()) {
        title.textContent = cleaned;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      setTimeout(run, 1500);
    });
  } else {
    run();
    setTimeout(run, 1500);
  }
})();
